export default __webpack_public_path__ + "static/media/04.26.24 Minutes of the Special Meeting of the BOD.96c8980b.pdf";